import { Component, OnInit, inject } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { RouterModule, RouterOutlet } from '@angular/router';
import { debounceTime, map } from 'rxjs';

import { CommonModule } from '@angular/common';
import { DEBUG_TOOLS } from './app.config';
import { LoginComponent } from '@core/components/login/login.component';
import { SidenavComponent } from '@core/components';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        CommonModule,
        RouterModule,
        LoginComponent,
        SidenavComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  public readonly showDebugTools: boolean = inject<boolean>(DEBUG_TOOLS);

  public title: string = 'Api Key Management';
  public isAuthenticated = false;
  public errorMessage?: string;
  public userInfo$ = this.oidcSecurityService.userData$.pipe(
    debounceTime(2000),
    map((user: UserDataResult) => user.userData['email'])
  );

  ngOnInit(): void {
    this.oidcSecurityService.isAuthenticated$.subscribe(
      ({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;
      }
    );

    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
      this.errorMessage = loginResponse.errorMessage;
    });
  }

  public login(): void {
    this.oidcSecurityService.authorize();
  }

  public logout(): void {
    this.oidcSecurityService
      .logoff()
      .subscribe((result) => console.info(result));
  }
}
